<template>
  <div>
    <div id="displayedMessagesContainer" class="mt-4 pt-3 m-2 col-6 col-lg-4 col-xl-3 bg-transparent text-secondary">
      <div class="display-message-animation mb-1 col" v-for="orderedDisplayedMessage in orderedDisplayedMessages" :key="'displayedMessage_'+orderedDisplayedMessage.id">

        <div v-if="orderedDisplayedMessage.type === 'OK'" :id="'divDisplayedMessageOk_'+orderedDisplayedMessage.id" class="alert alert-success alert-dismissible fade show bg-white mb-1 displayedMessageClass" role="alert">
          <span class="alert-icon"><span class="sr-only">Success</span></span>
          <p class="my-auto text-left resultMessageClass">{{ orderedDisplayedMessage.text }}</p>
          <button type="button" class="close" data-dismiss="alert" v-on:click="closeDisplayMessage(orderedDisplayedMessage.id)">
            <span class="sr-only">Close success message</span>
          </button>
        </div>

        <div v-if="orderedDisplayedMessage.type === 'INFO'" :id="'divDisplayedMessageInfo_'+orderedDisplayedMessage.id" class="alert alert-info alert-dismissible fade show bg-white mb-1 displayedMessageClass" role="alert">
          <span class="alert-icon"><span class="sr-only">Info</span></span>
          <p class="my-auto text-left resultMessageClass">{{ orderedDisplayedMessage.text }}</p>
          <button type="button" class="close" data-dismiss="alert" v-on:click="closeDisplayMessage(orderedDisplayedMessage.id)">
            <span class="sr-only">Close info message</span>
          </button>
        </div>

        <div v-if="orderedDisplayedMessage.type === 'ERROR'" :id="'divDisplayedMessageError_'+orderedDisplayedMessage.id" class="alert alert-danger alert-dismissible fade show bg-white mb-1 displayedMessageClass" role="alert">
          <span class="alert-icon"><span class="sr-only">Danger</span></span>
          <p class="my-auto text-left resultMessageClass" data-toggle="modal" data-target="#errorModalDetails" v-on:click="saveSelectedErrorToDisplayOnModal(orderedDisplayedMessage)">{{ orderedDisplayedMessage.text }}</p>
          <button type="button" class="close" data-dismiss="alert" v-on:click="closeDisplayMessage(orderedDisplayedMessage.id)">
            <span class="sr-only">Close danger message</span>
          </button>
        </div>

      </div>
    </div>

    <div class="modal fade" id="errorModalDetails" tabIndex="-1" aria-labelledby="errorModalDetailsTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="errorModalDetailsTitle">Error Details</h5>
            <button type="button" id="closeErrorModalDetailsButton" class="close" data-dismiss="modal" aria-label="Close">
            </button>
          </div>
          <div class="modal-body text-left">

            <label v-if="(errorToDisplayOnModal !== undefined) && (errorToDisplayOnModal.modalText !== undefined)">{{errorToDisplayOnModal.modalText}}</label>
            <label v-if="(errorToDisplayOnModal !== undefined) && (errorToDisplayOnModal.modalText === undefined)">{{errorToDisplayOnModal.text}}</label>
            <label v-if="(errorToDisplayOnModal === undefined)">No more information for this error</label>

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close">Close</button>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import MessageDisplayerService from '../../utils/MessageDisplayerService';
import Flip from '../../utils/Flip';

export default {
  name: "MessageDisplayer",
  data() {
    return {
      flip: new Flip(),
      errorToDisplayOnModal: undefined
    };
  },
  mounted() {
    MessageDisplayerService.startServiceUsingStore(this.$store);
  },
  updated: function() {
    let newDisplayedMessageClass = Array.from(document.querySelectorAll('.displayedMessageClass'));
    this.flip.play(newDisplayedMessageClass);
    this.flip = new Flip();
  },
  computed: {
    orderedDisplayedMessages: function() {
      return this.$store.state.displayedMessages;
    },
  },
  watch: {
    orderedDisplayedMessages(val, oldVal) {
      console.log(`[watch] [orderedDisplayedMessages] update ${(val && oldVal) ? '' : 'with missing value'}`);
      let newDisplayedMessageClass = Array.from(document.querySelectorAll('.displayedMessageClass'));
      this.flip.read(newDisplayedMessageClass);
    }
  },
  methods: {
    closeDisplayMessage(displayedMessageId) {
      MessageDisplayerService.removeMessage(displayedMessageId);
    },
    saveSelectedErrorToDisplayOnModal(error) {
      this.errorToDisplayOnModal = error;
    }
  }
}
</script>

<style scoped>
.alert-icon {
  width: 2.5rem;
}

.resultMessageClass {
  font-size: 0.9rem;
}

#displayedMessagesContainer {
  position: absolute;
  z-index: 2;
  right: 0;
}

.bg-dark .bg-white.alert-dismissible .close {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='%23000' stroke-width='5' stroke-linecap='round' d='M15 17.121l-8.132 8.132-2.121-2.12L12.879 15 4.747 6.868l2.12-2.121L15 12.879l8.132-8.132 2.12 2.121L17.122 15l8.132 8.132-2.121 2.12L15 17.123z'/%3e%3c/svg%3e")
}
</style>